<template>
  <div
    class="nav-content"
    :class="[{ isCollapse: isCollapse }]"
  >
    <div v-if="!isCollapse" class="menu-open">
      <div
        v-for="(item, $index) in processedMenuLists"
        :key="$index"
        class="panel"
        onselectstart="return false"
        :class="{ active: acitvePath.indexOf(item.path) > -1 }"
      >
        <template v-if="item.children.length > 1">
          <div class="nav-item" @click="setOpenIndex(item.path)">
            <div class="nav-mark">
              <svg-icon :iconClass="item.meta.icon" className="icon" />
              <span class="nav-title">{{ item.meta.title }}</span>
            </div>
            <i
              class="el-icon-arrow-right down"
              :class="{ deg: isOpenItem === $index }"
            />
          </div>
          <div
            class="child-content"
            :class="{ 'is-open': isOpenItem === $index }"
          >
            <div
              v-for="(child, key) in item.children"
              :key="key"
              class="child-item"
              :class="{ 'tab-active': acitvePath.indexOf(child.path) > -1 }"
              @click="goto(`${item.path}/${child.path}`)"
            >
              <span class="child-item-title">{{ child.meta.title }}</span>
              <span class="menu-count" v-if="child.meta.count !== undefined && child.meta.count !== null">({{child.meta.count}})</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="nav-item" @click="goto(`${item.path}${item.children[0]?.path ? `/${item.children[0]?.path}` :''}`)">
            <div class="nav-mark">
              <svg-icon :iconClass="item.meta.icon" className="icon" />
              <span class="nav-title">{{ item.meta.title }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="menu-close">
      <div v-for="(item, $index) in processedMenuLists" :key="$index" class="panel">
        <div
          class="nav-item"
          :class="{ active: acitvePath.indexOf(item.path) > -1 }"
        >
          <svg-icon :iconClass="item.meta.icon" className="icon" />
        </div>
        <div class="child-content">
          <!-- <div class="nav-close-title">{{ item.meta.title }}</div> -->
          <template v-for="(child, key) in item.children">
            <template v-if="item.children.length > 1">
              <p
                :key="key"
                class="sub-menu-item"
                :class="{ active: acitvePath.indexOf(child.path) > -1 }"
                @click="goto(`${item.path}/${child.path}`)"
              >
                {{ child.meta.title }}
              </p></template
              >
            <template v-else>
              <p
                :key="key"
                class="sub-menu-item"
                :class="{ active: acitvePath.indexOf(item.path) > -1 }"
                @click="goto(`${item.path}`)"
              >
                {{ child.meta.title }}
              </p></template
            >
          </template>
        </div>
      </div>
    </div>
    <div class="close" :style="{'left': isCollapse ? '60px' : '210px'}" @click="onCollapse">
      <i :class="{'el-icon-d-arrow-left' : !isCollapse, ' el-icon-d-arrow-right': isCollapse}" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserFolder} from '@/api/email'
export default {
  data() {
    return {
      acitvePath: '',
      isOpenItem: 1,
      emailFolders: []
    }
  },
  computed: {
    ...mapGetters(['isCollapse', 'menuLists']),
    processedMenuLists() {
      return this.menuLists.map(item => {
        let children = (item.children || []).filter(child => !child.meta?.hidden)
        if (item.path === '/emailCenter' && this.emailFolders.length > 0) {
          const folderChildren = this.emailFolders.map(folder => ({
            path: `emailDetail?folderId=${folder.id}`,
            name: `emailDetail_${folder.id}`,
            meta: {
              title: folder.folderName,
              code: item.meta.code,
              icon: 'folder',
              doc: '#emailDetail',
              count:folder.emailCount
            }
          }))
          children = [...children, ...folderChildren]
        }
        return {
          ...item,
          children
        }
      })
    }
  },
  watch: {
    $route(route) {
      const acitvePath = route.fullPath
      this.acitvePath = acitvePath
      this.isOpenItem = null
      this.setOpenIndex(acitvePath)
    }
  },
  created() {
    const acitvePath = this.$route.fullPath
    this.acitvePath = acitvePath
    this.isOpenItem = null
    this.setOpenIndex(acitvePath)
    this.$store.commit('CHANGE_COLLAPSE', false);
    
    this.initEmailFolder();
  },
  methods: {
    onCollapse() {
      this.$store.commit('CHANGE_COLLAPSE', !this.isCollapse)
    },
    async initEmailFolder(){
      await getUserFolder({hasSystemFolder:true}).then(res=>{
        if(res.success && res.data && res.data.length > 0 ){
          this.emailFolders = res.data
        }
      })
    },
    goto(path) {
      console.log(path)
      const query = this.$route.query
      if (query.menuCode) {
        this.$confirm('当前文档未保存，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(() => {
            this.$router.push(path)
          })
          .catch(() => {})
      } else {
        this.$router.push(path)
      }
    },
    setOpenIndex(path) {
      const index = this.menuLists.findIndex((a) => path.indexOf(a.path) > -1)
      if (this.isOpenItem !== index) {
        this.isOpenItem = index
      } else {
        this.isOpenItem = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav-content {
  height: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background-color:rgba(0, 0, 0, 0.5);
  text-align: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  .collapse {
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    padding: 0 20px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .nav-title {
    display: none;
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .child-item-title {
    margin-left: 35px;
  }
  .menu-open {
    width: 100%;
    height: calc(100% - 42px);
    overflow-x: hidden;
    overflow-y: auto;
    .panel {
      width: 100%;
      height: auto;
      margin-top: 5px;
    padding: 0 20px;
    box-sizing: border-box;
      cursor: pointer;
    }
    .nav-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      cursor: pointer;
      .nav-mark {
        display: flex;
        align-items: center;
      }
    }
    .child-content {
      position: relative;
      left: -20px;
      width: 210px;
      height: auto;
      background: #1f2d3d;
      color: rgb(191, 203, 217);
      line-height: 50px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      z-index: 9999;
      cursor: pointer;
      display: none;
    }
    .child-item {
      width: 100%;
      height: 50px;
    }
    .down {
      transition: all 0.2s;
    }
    .deg {
      transform: rotate(90deg);
    }
    .active {
      color:  #fff;
      background: #4B5C70;
    }
    .tab-active {
      color:  #fff;
      background: #1E88E5;
    }
    .is-open {
      display: block;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .menu-close {
    width: 100%;
    height: auto;
    .panel {
      width: 100%;
      height: 50px;
      margin-top: 5px;
      position: relative;
      cursor: pointer;
      &:hover .child-content {
        display: block;
      }
      &:hover {
        background: #263445;
      }
      .nav-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
      }
      .child-content {
        position: absolute;
        width: 140px;
        height: auto;
        background: #1f2d3d;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        left: 60px;
        top: 0;
        display: none;
        z-index: 999;
      }
      .nav-close-title {
        width: 100%;
        height: 48px;
        border-bottom: 1px solid #f2f7ff;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 48px;
      }
      .sub-menu-item {
        width: 100%;
        height: 19px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        padding-top: 16px;
        cursor: pointer;
        &:last-child {
          padding-bottom: 16px;
        }
        &:hover {
          color:  rgb(18,88,188);
        }
      }
      .active {
        color:  rgb(18,88,188);
      }
    }
  }
}
.nav-content:not(.isCollapse) {
  text-align: left;
  width: 100%;
  .nav-title {
    margin-left: 5px;
    display: inline;
  }
}
.nav-content {
  position: relative;
  .close {
    position: absolute;
    left: 160px;
    z-index: 1;
    top: 50%;
    margin-top: -64px;
    width: 16px;
    height: 108px;
    background: #304156;
    box-shadow: -4px 0px 6px 1px rgba(0, 0, 0, 0.08);
    writing-mode: vertical-lr;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    &::before{
        content:  '';
        width: 0;
        height: 0;
        top: -10px;
        position:absolute;
        border-bottom: 10px solid transparent;
        border-top: 10px solid transparent;
        border-left: 16px solid #304156;
    }
    &::after{
        content:  '';
        width: 0;
        height: 0;
        top: 99px;
        position:absolute;
        border-bottom: 10px solid transparent;
        border-top: 10px solid transparent;
        border-left: 16px solid #304156;
    }
  }
}

.menu-count{
  color: #35ab7e;
}
</style>
